import * as t from 'io-ts';

export const prismaticJwtTokenCodec = t.type({
  access_token: t.string,
  prismatic_customer_id: t.string,
});
